import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import BCLButton from '../../../common/Buttons/BCLButton';
import { FONT_WEIGHT } from '../../../../constants/common';

const styles = makeStyles((theme) => ({
  row: {
    padding: '10px 0'
  },
  rowSeparator: {
    borderBottom: props => `2px Dashed rgba(${props.configColors['--color_9']}, 0.45)`
  },
  title: {
    color: props => `rgb(${props.configColors['--color_3']})`,
    fontWeight: FONT_WEIGHT.bold,
    fontSize: '18px',
    marginBottom: '10px'
  },
  cell: {
    paddingLeft: '0',
    paddingRight: '0',
    fontSize: '16px',
    color: props => `rgb(${props.configColors['--color_3']})`
  },
  grid: {
    marginTop: '15px'
  },
  leftBlock: {
    color: props => `rgb(${props.configColors['--color_3']})`,
    fontSize: '16px',
    fontWeight: FONT_WEIGHT.bold
  },
  unknown: {
    color: props => `rgb(${props.configColors['--color_1']})`,
    cursor: 'pointer'
  },
  updateProfile: {
    textAlign: 'right',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center'
    }
  }
}));


const InsightsSHComparison = (props) => {
  const classes = styles(props);
  const { translations, shcData } = props;
  let shcString = "SIMILAR_HOMES.NEIGHBOURHOOD_COMPARISON.";

  return(
    <>
      <Grid container spacing={2} className={classes.grid}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={12}>
            <Typography component='h3' className={classes.title}>{translations[`${shcString}HEADING`]}</Typography>
          </Grid>
        </Grid>
        {shcData.map((row, index) => (
          <Grid container direction="row" justify="center" alignItems="center" key={index} className={`${classes.row} ${classes.rowSeparator}`}>
            <Grid item xs={6} sm={7} className={classes.cell}>
              {row.title}:
            </Grid>
            <Grid item xs={6} sm={5} align="right" className={`${classes.cell} ${(row.value === 'Unknown') ? classes.unknown : ''}`} onClick={(row.value === 'Unknown') ? () => props.goToSurvey(row.questionId) : null}>
              {row.value}
            </Grid>
          </Grid>
        ))}
        <Grid container direction="row" justify="center" alignItems="center" className={classes.row}>
          <Grid item xs={12} sm={7}>
            <Typography component="div" className={classes.leftBlock}>{translations[`${shcString}HELP_TEXT`]}</Typography>
          </Grid>
          <Grid item xs={12} sm={5} className={classes.updateProfile}>
            <BCLButton btnText={translations["SIMILAR_HOMES.UPDATE_HOME_PROFILE_TEXT"]} textColor={`rgb(${props.configColors['--color_1']})`} borderColor={`rgb(${props.configColors['--color_1']})`} onClick={(e) => props.goToSurvey()} hoverColor={`rgb(${props.configColors['--color_54']})`} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default InsightsSHComparison;
